// QS Bundle Picker: updates the native product form's variant id from the
// picker dropdowns. Loaded on every page, because the Quick Add modal
// injects product HTML without running inline scripts, so an inline script
// would never run there. Watches for pickers added later (Quick Add) and
// finds the variant input inside the same product info container, not by
// section id, which Quick Add rewrites.
(function () {
  function initPicker(root) {
    if (!root || root.dataset.qsInitialized) return;
    root.dataset.qsInitialized = 'true';
    var variants;
    try {
      variants = JSON.parse(root.dataset.variants || '[]');
    } catch (e) {
      return;
    }
    var selects = root.querySelectorAll('.qs-bundle-select');
    if (!selects.length) return;
    function update() {
      var container = root.closest('.product__info-container') || root.closest('product-info') || document;
      var variantInput = container.querySelector('.product-variant-id');
      if (!variantInput) return;
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) {
          variantInput.value = v.id;
          variantInput.disabled = !v.available;
          return;
        }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('.qs-bundle-picker').forEach(initPicker);
  }
  initAll();
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('qs-bundle-picker')) initPicker(node);
          initAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
